export const loading = {
	ar: "جاري التحميل",
	ca: "S'està carregant",
	ckb: "بارکردن",
	de: "Laden",
	en: "Loading",
	es: "Cargando",
	eu: "Kargatzen",
	fa: "در حال بارگذاری",
	fi: "Ladataan",
	fr: "Chargement",
	he: "טוען",
	hi: "लोड हो रहा है",
	ja: "読み込み中",
	ko: "로딩 중",
	lt: "Kraunama",
	nb: "Laster",
	nl: "Laden",
	pl: "Ładowanie",
	"pt-BR": "Carregando",
	pt: "A carregar",
	ro: "Se încarcă",
	ru: "Загрузка",
	sv: "Laddar",
	ta: "ஏற்றுகிறது",
	th: "กำลังโหลด",
	tr: "Yükleniyor",
	uk: "Завантаження",
	ur: "لوڈ ہو رہا ہے",
	uz: "Yuklanmoqda",
	"zh-CN": "加载中",
	"zh-TW": "載入中"
};
